import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { DASHBOARD_ROUTE, SIGNIN_ROUTE } from "../constants/RoutePaths";
import type { SweetAlertIcon, SweetAlertPosition } from "sweetalert2";

interface RouteProps {
  children: ReactNode;
}

interface AlertToastOptions {
  toast: boolean;
  position: SweetAlertPosition;
  titleText: string;
  icon: SweetAlertIcon;
  showConfirmButton: boolean;
  timer: number;
}

interface AlertOptions {
  position: SweetAlertPosition;
  icon: SweetAlertIcon;
  text: string;
  customClass: {
    confirmButton: string;
  };
  buttonsStyling: boolean;
  confirmButtonColor: string;
}

export function PublicRoute({ children }: RouteProps): React.ReactElement {
  const token = localStorage.getItem("AUTH_TOKEN");
  return !token ? <>{children}</> : <Navigate to={DASHBOARD_ROUTE} />;
}

export function PrivateRoute({ children }: RouteProps): React.ReactElement {
  const token = localStorage.getItem("AUTH_TOKEN");
  const location = window.location.href;
  return token ? <>{children}</> : <Navigate to={SIGNIN_ROUTE} state={location} />;
}
export function authHeader(): { Authorization: string | null } {
  const token = localStorage.getItem("AUTH_TOKEN");
  return { Authorization: token };
}
export const getAlertToast = (
  type: string = "success",
  text: string = "",
  timer: number = 5000
): AlertToastOptions => ({
  toast: true,
  position: "bottom",
  titleText: text,
  icon: type as SweetAlertIcon,
  showConfirmButton: false,
  timer: timer,
});

export const getAlert = (type: string = "success", text: string = ""): AlertOptions => ({
  position: "center",
  icon: type as SweetAlertIcon,
  text: text,
  customClass: {
    confirmButton: "btn-shadow btn btn-primary btn-lg",
  },
  buttonsStyling: false,
  confirmButtonColor: "#000",
});
